import { showElement } from './visibility';
import { AddressHtmlId, AppHtmlId } from '../enums/elementId';
import { ADDRESS_WRAPPER_TOP_MARGIN, DTAG, SELECTEDID_500 } from '../constants';

/**
 * Function to update Seal image
 *
 * @param selectedTariffId - Tariff id
 * @param accessSupplier - The supplier of the tarrif
 * @param contentEnabled - Boolean of content if its available
 * @param isAddress - Boolean of address if it's available
 */

export const updateSeal = (selectedTariffId: string, accessSupplier: string,
    contentEnabled: boolean, isAddress: boolean) => {
    const addressElement = document.getElementById(AddressHtmlId.ADDRESS_WRAPPER);

    if (SELECTEDID_500 === selectedTariffId &&
        ('' === accessSupplier || DTAG === accessSupplier) && contentEnabled)
    {
        showElement(AppHtmlId.SEAL_IMG, true);
        isAddress && addressElement && addressElement.classList.remove(ADDRESS_WRAPPER_TOP_MARGIN);

    } else {
        showElement(AppHtmlId.SEAL_IMG, false);
        addressElement && addressElement.classList.add(ADDRESS_WRAPPER_TOP_MARGIN);
    }
};
